<!-- Круг с галочкой для отмеченного состояния. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="9" :stroke="stroke" stroke-width="2" />
    <path
      d="m8 12 3 3 5-6"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CircleCheckIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
